import { put, SagaGenerator, select, takeLatest } from "typed-redux-saga";
import { Action } from "typescript-fsa";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { FormActivity, FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";

import { VERAKTUNG_LOCATION } from "../../../utilities/variables/modulfRuntimeAnnotations";
import { assertNonNullable, assertTrue } from "../../../utilities/assert";
import { createEventButtonActionMatcher } from "../../../utilities/actionUtils";
import { ModulfUiSelectors } from "../../../utilities/selectors/modulfUiSelectors";

import { ArchiveModuleFormDescriptor } from "../descriptors";

const ARCHIVE_SYSTEM_BY_EVENT = {
	archiveEldorado: "eldorado",
	archiveXakte: "xakte"
} as const;

export function* showArchiveDialogSaga(): SagaGenerator<void> {
	yield* takeLatest(createEventButtonActionMatcher(...Object.keys(ARCHIVE_SYSTEM_BY_EVENT)), handle);
}

function* handle(action: Action<FormEngineActions.FormEngineEventActions>): SagaGenerator<void> {
	const buttonAnnotations = yield* select(
		ModulfUiSelectors.selectButtonAnnotations(
			action.payload.activityId,
			action.payload.engineEvent.payload.buttonPath
		)
	);
	const archiveSystem =
		ARCHIVE_SYSTEM_BY_EVENT[action.payload.engineEvent.payload.name as keyof typeof ARCHIVE_SYSTEM_BY_EVENT];

	const data = yield* select(ActivitySelectors.data(action.payload.activityId));
	assertTrue(FormActivity.Data.SingleDocumentData.isInstance(data));
	const veraktungLocationAnnotationValue = buttonAnnotations.find(it => it.name === VERAKTUNG_LOCATION)?.value;
	assertNonNullable(veraktungLocationAnnotationValue);
	const archiveLocation = "/" + veraktungLocationAnnotationValue.split("/").slice(1).join("/");
	yield* put(
		ActivityActions.create({
			activityDescriptor: ArchiveModuleFormDescriptor.build({
				sourceActivityId: action.payload.activityId,
				archiveLocation,
				archiveSystem,
				instance: data.document.id
			}),
			loadingState: "missing"
		})
	);
}
